const colors = {
    primary: "#813333",
    primaryHover: "#672929",
    disabled: "#CCCCCC"
}

export default colors;